import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';

import { AuthService } from '@services/auth.service';

@Directive({
  selector: '[isAllowedByRole]',
})
export class IsAllowedByRoleDirective {
  constructor(
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService,
  ) {}

  @Input() set isAllowedByRole(role: string[]) {
    this.authService.doesUserHaveRequirementRole(role).subscribe((isAllowed) => {
      if (isAllowed) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
